// File: src/pages/Unauthorized.tsx
import React, { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function Unauthorized() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Set page title
  useEffect(() => {
    document.title = 'Access Denied';
  }, []);

  const requiredRole = user?.role === 'admin' ? 'branch' : 'admin';

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full text-center space-y-6 p-6">
        <div className="rounded-full bg-amber-100 p-3 w-16 h-16 flex items-center justify-center mx-auto">
          <AlertTriangle className="h-8 w-8 text-amber-600" />
        </div>
        <h1 className="text-3xl font-bold">Access Denied</h1>
        <p className="text-muted-foreground">
          You don't have permission to access this page. This area is restricted to{' '}
          <span className="font-medium">{requiredRole}</span> users.
        </p>
        <div className="pt-4">
          <Button onClick={() => navigate('/')}>Return to Dashboard</Button>
        </div>
      </div>
    </div>
  );
}